import SuggestedSproutSettingBox from "@/parts/TipsTricksSection/SuggestedSproutSettingBox";
import React from "react";
import { ContentItem } from "@api";

interface ISuggestedSproutSettingsSectionProps {
    pageContent: Record<string, ContentItem>;
    imageDirectory?: string;
}

const SuggestedSproutSettingsSection = ({ pageContent, imageDirectory = '/images/tips-tricks/' }: ISuggestedSproutSettingsSectionProps) => (
    <div className='p-10 font-normal'>
        <div className='text-center pb-10'>
            <div className='flex flex-col items-center'>
                <h4 className='max-w-[500px] max-md:text-3xl pb-2.5'>
                    {pageContent['sense.sprout-battery.suggested-settings.headline']?.data}</h4>
                <p className='max-w-[800px]'>
                    {pageContent['sense.sprout-battery.suggested-settings.body']?.data}</p>
            </div>
        </div>

        <div className="grid grid-cols-3 gap-6 max-md:gap-16 max-md:grid-cols-1">
            {
                ['premium', 'low', 'thick'].map((boxName) => (
                    <SuggestedSproutSettingBox
                        key={`${boxName}`}
                        boxName={boxName}
                        pageContent={pageContent}
                        imageDirectory={imageDirectory}
                    />
                ))
            }
        </div>

        <div className='text-center text-2xl font-semibold max-w-[514px] mx-auto mt-10 mb-20 max-md:hidden'>
            <p className='text-[#F26922]'>{pageContent['sense.sprout-battery.pro-tip.headline']?.data}</p>
            <p>{pageContent['sense.sprout-battery.pro-tip.body']?.data}</p>
        </div>
    </div>
)

export default SuggestedSproutSettingsSection;
